import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "antd";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { AccountMenuDropdown } from "./AccountMenuDropdown";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";
import { AccountMenuItem } from "./accountMenu.model";
import "@companion-core/web/src/Assets/Styles/scss/accountMenu.scss";

interface AccountLink {
  name: string;
  icon: string;
}

export const AccountMenu = () => {
  const { t } = useTranslation();
  const { config } = useConfigStore();
  const options = useMemo(() => config?.options, [config]);
  const accountLinks = useMemo(() => (options?.accountLinks as AccountLink[]) ?? [], [options]);
  const accountIcon = useMemo(() => (options?.accountIcon as string) ?? "JP-User", [options]);
  const [open, setOpen] = useState(false);

  const items: AccountMenuItem[] = useMemo(
    () =>
      accountLinks.map((accountLink: AccountLink) => {
        const { name, icon } = accountLink;
        return {
          name,
          label: (
            <span className="body-text-6" data-testid={`account-item-${name}`}>
              {t(`common.header.links.${name}`)}
            </span>
          ),
          icon: <FontIcon name={icon} size={24} />,
        } as AccountMenuItem;
      }),
    [accountLinks]
  );

  return (
    <div className="account-menu" data-testid="account-menu">
      <Dropdown
        classNames={{ root: "account-menu__dropdown" }}
        trigger={["click"]}
        onOpenChange={(open) => setOpen(open)}
        popupRender={() => <AccountMenuDropdown items={items} />}>
        <button
          type="button"
          data-testid="account-menu__trigger"
          aria-label={t(
            `common.accessibility.header.buttons.profile.label.${open ? "open" : "closed"}`
          )}
          aria-live="polite"
          className="account-menu__container">
          <FontIcon
            data-testid="account-menu__icon"
            className="account-menu__icon"
            aria-hidden="true"
            name={accountIcon}
            size={24}
          />
        </button>
      </Dropdown>
    </div>
  );
};
